import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {useModule} from '../../platform/modules'

export function Logout() {
  const {logout} = useAuth()
  const {clearModule} = useModule()
  useEffect(() => {
    logout()
    clearModule()
    document.location.reload()
  }, [clearModule, logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
